(() => {
  if (customElements.get('size-guide-drawer')) return;

  class SizeGuideDrawer extends HTMLElement {
    constructor() {
      super();
      this.onOpenClick = this.onOpenClick.bind(this);
      this.onCloseClick = this.onCloseClick.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
      this.previouslyActiveElement = null;
      this.scrollFreezeTimeoutId = null;
    }

    connectedCallback() {
      this.popup = this.querySelector('[data-js-size-guide-popup]');
      this.openTriggers = this.querySelectorAll('[data-js-size-guide-open]');

      if (!this.popup) return;

      this.closeTriggers = this.popup.querySelectorAll('[data-js-size-guide-close]');

      if (this.popup.parentElement !== document.body) {
        document.body.appendChild(this.popup);
      }

      this.openTriggers.forEach((el) => el.addEventListener('click', this.onOpenClick));
      this.closeTriggers.forEach((el) => el.addEventListener('click', this.onCloseClick));
    }

    disconnectedCallback() {
      this.openTriggers?.forEach((el) => el.removeEventListener('click', this.onOpenClick));
      this.closeTriggers?.forEach((el) => el.removeEventListener('click', this.onCloseClick));
      window.removeEventListener('keydown', this.onKeydown);
      this.unlockScroll();

      if (this.popup?.parentElement === document.body) {
        this.popup.remove();
      }
    }

    onOpenClick(event) {
      event.preventDefault();
      this.open();
    }

    onCloseClick(event) {
      event.preventDefault();
      this.close();
    }

    onKeydown(event) {
      if (event.key === 'Escape' || event.keyCode === 27) {
        this.close();
      }
    }

    open() {
      if (!this.popup) return;

      this.lockScroll();
      this.popup.classList.add('cc-popup--visible');
      this.popup.setAttribute('aria-hidden', 'false');
      this.previouslyActiveElement = document.activeElement;

      window.addEventListener('keydown', this.onKeydown);

      setTimeout(() => {
        const closeButton = this.popup.querySelector('.cc-popup-close');
        closeButton?.focus();
      }, 250);
    }

    close() {
      if (!this.popup) return;

      this.popup.classList.remove('cc-popup--visible');
      this.popup.setAttribute('aria-hidden', 'true');
      window.removeEventListener('keydown', this.onKeydown);

      if (this.previouslyActiveElement) {
        this.previouslyActiveElement.focus();
        this.previouslyActiveElement = null;
      }

      this.unlockScroll();
    }

    lockScroll() {
      if (!this.popup?.dataset.freezeScroll) return;

      clearTimeout(this.scrollFreezeTimeoutId);
      document.body.classList.add('cc-popup-no-scroll');

      const scrollDiv = document.createElement('div');
      scrollDiv.className = 'popup-scrollbar-measure';
      document.body.appendChild(scrollDiv);
      const scrollbarWidth = scrollDiv.getBoundingClientRect().width - scrollDiv.clientWidth;
      document.body.removeChild(scrollDiv);

      if (scrollbarWidth > 0) {
        document.body.style.paddingRight = `${scrollbarWidth}px`;
        document.body.classList.add('cc-popup-no-scroll-pad-right');
      }
    }

    unlockScroll() {
      if (!this.popup?.dataset.freezeScroll) return;

      const visibleFreezePopups = document.querySelectorAll(
        '.cc-popup--visible[data-freeze-scroll="true"]'
      );
      if (visibleFreezePopups.length > 0) return;

      let transitionDuration = 250;
      const innerModal = this.popup?.querySelector('.cc-popup-modal');
      if (innerModal) {
        const parsed = parseFloat(getComputedStyle(innerModal).transitionDuration);
        if (parsed > 0) transitionDuration = parsed * 1000;
      }

      this.scrollFreezeTimeoutId = setTimeout(() => {
        document.body.classList.remove('cc-popup-no-scroll');
        document.body.classList.remove('cc-popup-no-scroll-pad-right');
        document.body.style.paddingRight = '0';
      }, transitionDuration);
    }
  }

  customElements.define('size-guide-drawer', SizeGuideDrawer);
})();
